// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
import menuOpen from "./menuOpen";
import infiniteScroll from "./infiniteScroll";
import scrollReveal from "./scrollReveal";


// Call the menu, infinite scroll, and scroll reveal functions
menuOpen();
infiniteScroll();
scrollReveal();

// Neon is dark-only — no color scheme toggle needed